// extracted by mini-css-extract-plugin
export default {"SubFunction":"SubFunction_SubFunction__dEF5J"};